import { getIconComponent, getTagDisplayStyle } from '../tagUtils'
import styles from './PostComposer.module.css'

export function TagChipContent({ tag, fallbackLabel, iconSize = 12 }) {
  const TagIcon = getIconComponent(tag?.icon)

  return (
    <span className={styles.tagPreview} style={getTagDisplayStyle(tag)}>
      {TagIcon ? <TagIcon size={iconSize} aria-hidden="true" /> : null}
      {tag?.label || fallbackLabel || ''}
    </span>
  )
}
